// src/api/services/teams.js
import apiClient from '../client';

export const teamService = {
    // Načtení všech týmů uživatele
    getTeams: () => apiClient.get('/api/teams'),
    getTeamsAdministrated: () => apiClient.get('/api/teams/administrated'),

    // Vytvoření nového týmu
    createTeam: (teamData) => apiClient.post('/api/teams/create', teamData),

    // Získání detailu týmu
    getTeamDetail: (teamId) => apiClient.get(`/api/teams/${teamId}`),

    // Aktualizace týmu
    updateTeam: (teamId, teamData) => apiClient.put(`/api/teams/${teamId}`, teamData),

    // Smazání týmu
    deleteTeam: (teamId) => apiClient.delete(`/api/teams/${teamId}/delete`),

    // Přidání uživatele do týmu
    addTeamMember: (teamId, userData) => apiClient.post(`/api/teams/${teamId}/members/add`, userData),

    // Odebrání uživatele z týmu
    getWebsitesFromTeam: (teamId, websiteId) => apiClient.get(`/api/teams/${teamId}/websites`),

    // Přiřazení webu k týmu
    removeTeamMember: (teamId, userId) => apiClient.delete(`/api/teams/${teamId}/members/${userId}/remove`),
    assignWebsiteToTeam: (teamId, websiteId) => apiClient.post(`/api/website-assignments/assign-to-team`, {teamId, websiteId}),
    // Odebrání webu z týmu
    removeWebsiteFromTeam: (teamId, websiteId) => apiClient.delete(`/api/teams/${teamId}/websites/${websiteId}`)
};

export default teamService;